import axios from 'axios';
import { ENV_CONFIG } from '../../../config/config';

export const tokenApi = axios.create({
    baseURL: `${ENV_CONFIG.URL_TOKEN}`,
}).get(``);